import router from './router'
import store from "./store";
import { getToken } from "@/utils/auth";
import {Message} from "element-ui";

const WHITE_LIST = ['/login'];  // 不重定向白名单

router.beforeEach((to, from, next) => {
  console.log(to)
  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
    } else {
      if (store.getters.roles == null || store.getters.roles.length === 0) {
        store.dispatch('GetUserInfo').then(response => {
          const menus = response.data.menus;
          const username = response.data.username;
          store.dispatch('GenerateRoutes', { menus, username}).then(() => {
            if (store.getters.addRouters) {
              store.getters.addRouters.forEach(route => {
                router.addRoute(route);
              })
            }
            next({ ...to, replace: true });
          });
        }).catch(e => {
          store.dispatch('FedLogout').then(() => {
            Message.error(e || 'Verification failed, please login again');
            next({path: '/'});
          })
        });
      } else {
        next();
      }
    }
  } else {
    if (WHITE_LIST.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js